import { render, staticRenderFns } from "./homeMenu.vue?vue&type=template&id=0fc4d346&scoped=true&"
import script from "./homeMenu.vue?vue&type=script&lang=js&"
export * from "./homeMenu.vue?vue&type=script&lang=js&"
import style0 from "./homeMenu.vue?vue&type=style&index=0&id=0fc4d346&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4d346",
  null
  
)

export default component.exports